import React from "react";
import "./conclave css files/heroconclavemain.css";
import NavbarConclave from "./NavbarConclave";
const future_global_text = require("../../assets/conclave assets/future_global_text.svg");
const design1 = require("../../assets/conclave assets/form_dots.png");
const design2 = require("../../assets/conclave assets/gray_dots.png");

function HeroSectionConclave() {
  return (
    <section className="hero_section_conclave_main_container">
      <NavbarConclave />
      <div className="hero_section_under_container">
        <div className="hero_flex_container">
          <div className="first_hero_section_container">
            <div className="btn_nine_text">
                Agenda Of The Conclave
            </div>
            <div className="future_global_text_container">
              <img src={future_global_text.default} alt="future_text" />
            </div>
            <button className="btn_nine_text">
              9<span className="small_text_th">th</span> June, Roseate House,
              New Delhi
            </button>
          </div>
          <div className="sec_hero_section_container">
            <div className="blue_container_for_register">
              <div className="design_text_container">
                <div className="design_container_register">
                  <img src={design1} className="design_self" alt="design" />
                </div>

                <p className="register_conclave_heading_text">
                  REGISTER FOR CONCLAVE
                </p>
              </div>

              <div className="all_text_input_container">
                <form className="form_conclave_container">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    autoComplete="off"
                    placeholder="Name *"
                    className="conclave_register_input"
                  />
                  <br />
                  <input
                    type="text"
                    id="name"
                    autoComplete="off"
                    name="name"
                    placeholder="Designation *"
                    className="conclave_register_input"
                  />
                  <br />
                  <input
                    type="text"
                    autoComplete="off"
                    id="name"
                    name="name"
                    placeholder="Organization *"
                    className="conclave_register_input"
                  />
                  <br />
                  <input
                    type="email"
                    id="name"
                    autoComplete="off"
                    name="name"
                    placeholder="Email *"
                    className="conclave_register_input"
                  />
                  <br />
                  <input
                    type="number"
                    autoComplete="off"
                    id="number"
                    name="number"
                    placeholder="Phone *"
                    className="conclave_register_input"
                  />
                  <br />

                  <select
                    name="queries"
                    id="queries"
                    className="conclave_register_input"
                  >
                    <option value="">Sponsorship Query *</option>
                    <option value="query2">YES</option>
                    <option value="query3">NO</option>
                    
                  </select>

                  <div className="register_now_btn_container">
                    <button className="register_now_btn">REGISTER NOW</button>
                  </div>
                </form>
              </div>
              <div className="design2_container">
                <img src={design2} alt="design" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSectionConclave;
